<template lang="pug">
.time-live-group
  .time-text(v-if="time === 'morning'") 上午時段
  .time-text(v-if="time === 'afternoon'") 下午時段
  .time-text(v-if="time === 'night'") 晚上時段
  .timetable-item(v-for="(courses, start_time) in course_list")
    //- 時間
    .item-time-box
      .item-time {{ start_time }}
    //- 課程區塊
    .item-content-box
      .item-content(
        v-for="(course, index_in) in courses",
        :courseLang="course.course_lang"
        :courseType="course.course_classtype"
        v-bind:class="confirmColor(course.is_expired, course.course_lang, course.course_classtype)"
      )
        .item-up
          .item-title {{ course.course_zname }}
          .item-title {{ course.course_fname }}

        .item-down
          //- 課程資訊
          .coruse-length-info 
            span {{ course.coures_teacher.name }}
            span {{ course.course_grade }}

        //- 進入直播課程
        img.item-enter(
          src="@/assets/images/menu-live-b.png",
          @click="clickOptionIn(course, 'live')"
        )
    .clearfix
</template>

<script>
export default {
  props: {
    // eslint-disable-next-line vue/require-prop-type-constructor
    time: false,
    course_list: {}
  },
  data () {
    return {

    }
  },
  watch: {

  },
  created () {

  },
  methods: {
    // 確認語系對應的顏色
    confirmColor (_isExpired = false, _courseLang = '', _courseType = '') {
      // 當課程已經結束
      if (_isExpired) {
        // return 'bg-gray-1'
      }

      // 根據語言判斷顏色
      let color = ''
      switch (_courseLang) {
        case 'en':
          color = 'bg-purple'
          break

        case 'ja':
          color = 'bg-orange'
          break

        default:
          color = 'bg-green'
          break
      }

      let textcolor = ''
      switch (_courseType) {
        case 'MS':
        case 'CD':
          textcolor = 'course-ms'
          break;
        case 'QT':
          textcolor = 'course-qt'
          break;
      }

      return color + ' ' + textcolor
    },
    // 點擊開啟直播功能
    clickOptionIn (_course, _type) {
      this.$emit('clickOptionOut', _course, _type)
    },
  }
}
</script>
<style lang="sass" scoped>
.time-live-group
  margin-top: .5rem
  width: 33.33333%
  float: left
  padding-right: 3rem
  .time-text
    color: #2e50ff
    text-align: left
    margin-bottom: .5rem
    font-size: .8rem
    font-weight: 500
  .nottime
    padding-top: 30vmin
    color: #191d35
    font-size: 4.3vmin
    font-weight: 500
    line-height: 6vmin
    text-align: center
  .timetable-item
    margin: 0 0 1rem 0
    position: relative
    cursor: pointer
    .item-time-box
      width: 4rem
      text-align: left
      float: left
      font-size: .8rem
      line-height: 1.5rem
      font-weight: 500
      color: #191d35
      .item-time
    .bg-gray-1
      background: #D4D4D4
    .bg-purple
      background: #cceafb
    .bg-green
      background: #e7bbfc
    .bg-orange
      background: #fadbe8

    .item-content-box
      padding-right: 1rem
      width: calc(100% - 4rem)
      float: left

      .item-content
        border-radius: 10px
        width: 100%
        padding: .5rem 1rem
        margin-bottom: .6rem
        position: relative
        min-height: 5rem
      .item-up
        &:active
          opacity: .7
      .item-enter
        position: absolute
        right: .5rem
        bottom: .5rem
        width: 2rem
      .item-down
        margin-top: .5rem
        position: relative
        text-align: left
        width: 100%
        .coruse-length-info
          color: #91a1c1
          font-size: .8rem
          font-weight: 500
          margin: 0
          span
            color: #91a1c1
        .teacher-box
          margin: .2vmin 0
          .teacher-name
            color: #191d35
            font-size: .9rem
            font-weight: 600
            line-height: 1.6rem
            margin: .6rem 0
            float: left
            max-width: 9rem
            margin-top: .8rem
            span
              // color: #91a1c1
              font-size: .85rem
              font-weight: 500
              margin-left: .5rem
              text-align: left
        .coruse-length
          color: #91a1c1
          font-size: .8rem
          font-weight: 500
          line-height: 1.2rem
          padding-bottom: 1rem
          width: 9rem

      .item-title
        width: calc(100% - 4vmin)
        color: #191d35
        font-size: .8rem
        font-weight: 500
        line-height: 1rem
        text-align: justify
        overflow: hidden
        text-overflow: ellipsis
        display: -webkit-box
        -webkit-line-clamp: 2
        -webkit-box-orient: vertical
        white-space: normal
      .item-student-num-text
        height: 1.3rem
        position: relative
        margin-top: .3rem
        text-align: right
        color: #191d35
        font-weight: 500
        font-size: .8rem

      .item-point
        float: left
        border-radius: 50%
      .point-purple
        background: #8086ff
        width: .5rem
        height: .5rem
        margin: .5rem .5rem .4em 0rem
      .point-green
        background: #49b583
        width: .5rem
        height: .5rem
        margin: .5rem .5rem .4em 0rem
      .point-orange
        background: #ffbd69
        width: .5rem
        height: .5rem
        margin: .5rem .5rem .4em 0rem
      .point-purple-border
        border: 2px solid #8086ff
        width: .5rem
        height: .51rem
        margin: .4rem .5rem .4em 0rem
      .point-green-border
        border: 2px solid #49b583
        width: .5rem
        height: .51rem
        margin: .4rem .5rem .4em 0rem
      .point-orange-border
        border: 2px solid #ffbd69
        width: .5rem
        height: .51rem
        margin: .4rem .5rem .4em 0rem

.course-ms
  .item-title,.item-down .coruse-length-info span
    color: #035EF5 !important

.course-qt
  .item-title,.item-down .coruse-length-info span
    color: #663399 !important
</style>
